<template>
    <div class="dataForm">
      <div>
        <div class="form-title mb-10 mt-10">
          <span class="label green" >业</span>
          <span class="left">业务基本信息</span>
        </div>
        <el-descriptions>
          <el-descriptions-item label="业务编号：">{{businessDetail.no}}</el-descriptions-item>
          <el-descriptions-item label="公司名称：">{{businessDetail.customerCompanyName}}</el-descriptions-item>
          <el-descriptions-item label="业务品牌：">{{businessDetail.brand}}</el-descriptions-item>
          <el-descriptions-item label="业务名称：">{{businessDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="型号：">{{businessDetail.model}}</el-descriptions-item>
          <el-descriptions-item label="序列号：">{{businessDetail.serial}}</el-descriptions-item>
          <el-descriptions-item label="数量：">{{businessDetail.amount}}</el-descriptions-item>
          <el-descriptions-item label="单位：">{{businessDetail.unit}}</el-descriptions-item>
          <el-descriptions-item label="业务类型：">{{businessDetail.type}}</el-descriptions-item>
          <el-descriptions-item label="维修状态：">{{businessDetail.repairType}}</el-descriptions-item>
          <el-descriptions-item label="外包公司：">{{businessDetail.outsourceCompanyName}}</el-descriptions-item>
          <el-descriptions-item label="外包公司联系人：">{{businessDetail.outsourceCompanyContactName}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="businessDetail.orderNo">
        <div class="form-title mb-10">
          <span class="label blue" >订</span>
          <span class="left">订单信息</span>
        </div>
        <OrderFeeDesc :detail="businessDetail">
          <template v-slot:before>
            <el-descriptions-item label="订单编号：">{{businessDetail.orderNo}}</el-descriptions-item>
          </template>

        </OrderFeeDesc>
      </div>
      <el-form
        class="mb-20"
        :ref="el => dataForm[index] = el"
        :model="item"
        label-position="top"
        label-width="100px"
        v-for="(item, index) in fromFieldData"
        :key="index"
        :disabled="formDisabled"
      >
        <div class="form-title">
          <span class="label" :class="item.labelClass">{{item.labelName}}</span>
          <span class="left">{{item.title}}</span>
          <span @click="handleAdd(item)" class="add-icon add-title cursor" v-if="item.type === 2 && !item.formList.length && canAdd" >
            <i class="iconfont icon-tubiao-25"></i>
          </span>
        </div>
        <div v-if="item.type === 1" class="underlineForm">
          <template v-for="(fields, k) in item.formList" :key="k" >
            <el-form-item
              :class="[fields.componentType, { fullWidth: fields.config.width }, { redBorder: fields.config.colorTheme === 1 }, { greenBorder: fields.config.colorTheme === 2 }]"
              :error="fields.rules[0].message"
              :rules="fields.rules"
              :prop="'formList.' + k + '.value'"
              :label="fields.fieldName"
              v-if="handleVisible(fields, item.formList)"
            >
              <FromField :fields="fields" @form-change="handleChange(fields, item.formList)" :id="id" v-if="fields.componentType !== 'el-calc'"/>
              <div v-else class="form-calc">
                  {{calcRate(fields, item.formList)}}
                </div>
            </el-form-item>
          </template>
        </div>
        <template v-if="item.type === 2" >
          <div v-for="(j, k) in item.formList" :key="k" class="border-container">
            <template v-for="(fields, i) in j.list" :key="i" >
              <el-form-item
                :class="[fields.componentType, { fullWidth: fields.config.width }]"
                :rules="fields.rules"
                :prop="'formList.' + k + '.list.' + i + '.value'"
                :label="fields.fieldName"
                :error="fields.rules[0].message"
                v-if="handleVisible(fields, j.list)"
              >
                <FromField :fields="fields" @form-change="handleChange(fields, j.list)" :id="id" v-if="fields.componentType !== 'el-calc'"/>
                <div v-else class="form-calc">
                  {{calcRate(fields, j.list)}}
                </div>
              </el-form-item>
            </template>
            <i @click="handleDelete(item.formList, k)" class="delete-icon" v-if="canAdd"/>
            <span @click="handleAdd(item)" class="add-icon cursor add-list" v-if="k === item.formList.length - 1 && canAdd">
              <i class="iconfont icon-tubiao-25"></i>
            </span>
        </div>
      </template>
    </el-form>

    <div class="dialog-footer mt-20" v-if="isShowCloseBtn || isShowSubmitBtn">
      <el-button @click="cancle" v-if="isShowCloseBtn" type="danger">
        {{ t('table.cancel') }}
      </el-button>
      <el-button
        v-if="isShowSubmitBtn"
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t('table.confirm') }}
      </el-button>
    </div>
  </div>
</template>
<script lang='ts'>
import { defineComponent, reactive, toRefs, ref, nextTick, onMounted, unref, PropType } from 'vue'
import { ElMessage } from 'element-plus'
import { createMarketFee, updateMarketFee } from '@/apis/BusinessMarketFee'
import { getPageList } from '@/apis/Form'

import { ArrayRowsItem } from '@/model/Index'
import { FormDataModel } from '@/model/FormModel'
import FromField from '@/components/common/FormField.vue'
import OrderFeeDesc from '@/views/order/OrderFeeDesc.vue'

import { cloneDeep } from 'lodash'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: { FromField, OrderFeeDesc },
  props: {
    id: { type: Number, required: true },
    initFormData: { type: Array as PropType<Array<FormDataModel>>, required: true },
    fromFieldData: { type: Array as PropType<Array<FormDataModel>>, required: true },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    isShowCloseBtn: { type: Boolean, required: false, default: true },
    isShowSubmitBtn: { type: Boolean, required: false, default: true },
    formDisabled: { type: Boolean, required: false, default: false },

    submitParams: { type: Object, required: false, default: () => {} },
    commandState: { type: String, required: false },
    method: { type: String, required: false },
    canAdd: { type: Boolean, required: false, default: true },
    businessDetail: { type: Object }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()
    const dataForm = ref([])

    const dataMap = reactive({
      fromFieldData: props.fromFieldData,
      submitLoading: false,
      deleteList: [] as ArrayRowsItem,
      conractMarketUserList: [] as ArrayRowsItem,
      handleChange(fields: any, formList: any) {
        // 业务模块的单独逻辑
        if (fields.fieldKey === 'customerCompanyId') {
          if (fields.value) {
            const selectItem = fields.option.filter((item: any) => {
              return item.id === fields.value
            })[0]
            console.log(selectItem, fields.option)
            // if (!selectItem) {
            //   return
            // }
            const {
              salesManId,
              salesMan
            } = selectItem || {}

            formList.forEach((formItem: any) => {
              if (formItem.fieldKey === 'customerCompanyContactId') {
                const isMultiple = formItem.config.multiple
                if (formItem.config.customerCompanyId && formItem.config.customerCompanyId !== fields.value) {
                  formItem.value = ''
                  formItem.option = []
                }
                formItem.config.customerCompanyId = fields.value
                formItem.config.params = {
                  companyId: fields.value
                }

                const _url = formItem.config.url
                const params = {
                  page: 1,
                  size: 1000,
                  companyId: fields.value
                }
                getPageList(_url, params).then((res: any) => {
                  formItem.option = res || []
                  if (formItem.option && formItem.option.length) {
                    formItem.value = isMultiple ? [formItem.option[0].id] : formItem.option[0].id
                    dataMap.handleAccountDefault(formList, formItem.option[0].accounts)
                  }
                })
              } else if (formItem.fieldKey === 'salesManId') {
                if (!selectItem) {
                  return
                }
                formItem.option = [{
                  id: salesManId,
                  name: salesMan
                }]
                formItem.value = salesManId
              }
            })
          } else {
            formList.forEach((formItem: any) => {
              if ((formItem.fieldKey === 'customerContactIds' || formItem.fieldKey === 'customerCompanyContactId') && formItem.config.customerCompanyId) {
                formItem.value = ''
                formItem.option = []
              } else if (formItem.fieldKey === 'salesManId') {
                formItem.value = ''
                formItem.option = []
              }
            })
          }
        } else if (fields.fieldKey === 'customerCompanyContactId' && fields.value) {
          const temp = fields.option.find((kk: any) => kk.id === fields.value)
          dataMap.handleAccountDefault(formList, temp?.accounts)
        }
        // 不知道有用没，不敢删
        if (fields.fieldKey === 'payType' && fields.config.mode === 'marketFee') {
          // 市场费支付方式选后，回显联系人信息
          const contactItem = formList.find((k: any) => k.fieldKey === 'customerCompanyContactId') || {}
          if (contactItem.value && fields.value) {
            getPageList(`customerCompanyContactPay?contactId=${contactItem.value}`).then((result: any) => {
              const tempAccount = result.filter((k: any) => {
                return k.type === fields.value
              })
              if (tempAccount[0]) {
                formList.forEach((formItem: any) => {
                  if (formItem.fieldKey === 'payee') {
                    formItem.value = tempAccount[0].name
                  } else if (formItem.fieldKey === 'paymentAccount') {
                    formItem.value = tempAccount[0].account
                  }
                })
              }
            })
          } else {
            formList.forEach((formItem: any) => {
              if (formItem.fieldKey === 'payee') {
                formItem.value = ''
              } else if (formItem.fieldKey === 'paymentAccount') {
                formItem.value = ''
              }
            })
          }
        } else if (fields.fieldKey === 'customerContactIds' && fields.config.mode === 'marketUser' && (fields.config.oldValue !== (fields.value && fields.value.join()))) {
          if (fields.value && fields.value.length) {
            const selectList = fields.option.filter((k: any) => {
              return fields.value.includes(k.id) && k.marketUser
            })
            dataMap.conractMarketUserList = selectList
          } else {
            dataMap.conractMarketUserList = []
          }
          fields.config.oldValue = fields.value || fields.value.join()
        }
      },
      handleAccountDefault(formList: any, accounts: any) {
        accounts = accounts || []
        formList.forEach((formItem: any) => {
          if (formItem.fieldKey === 'account') {
            formItem.option = accounts
            formItem.value = formItem.value || accounts[0] || ''
          }
        })
      },
      handleVisible(fields: any) {
        if (!fields.config.isHide) {
          return true
        } else {
          return false
        }
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleAdd(item: any) {
        const temp = props.initFormData.find((k: any) => k.title === item.title)
        const addContion = temp ? temp.formList : null
        const _temp = cloneDeep(addContion && addContion[0])
        item.formList.push(_temp)
        dataMap.clearValidate()
        dataMap.handleDefaultCustomerCompanyId()
      },
      handleDelete(formList: any, index: number) {
        const row = formList[index]
        if (row.id) {
          dataMap.deleteList.push(row)
        }
        formList.splice(index, 1)
      },
      handleSubmit() {
        const Forms = unref(dataForm)
        const promises = Forms.map((form: any) => {
          return form.validate()
        })
        Promise.all(promises).then(async() => {
          dataMap.submitLoading = true
          try {
            let tempData = dataMap.handleFormData(cloneDeep(dataMap.fromFieldData))
            tempData = Object.assign(tempData, props.submitParams)
            const formSate = (!props.id || props.commandState === 'copy') ? 'add' : 'edit'
            let result = null
            if (formSate === 'add') {
              result = await createMarketFee(props.api, tempData, props.method)
            } else {
              result = await updateMarketFee(props.id, tempData)
            }
            dataMap.submitLoading = false
            context.emit('update:visibel')
            context.emit('submit', result)
            ElMessage({
              message: !props.id ? '创建成功' : props.commandState === 'copy' ? '复制成功' : '编辑成功',
              type: 'success',
              duration: 2000
            })
          } catch (err: any) {
            console.log(err, 'err')
            dataMap.submitLoading = false
            if (err && err.errors) {
              err.errors.forEach((item: any) => {
                dataMap.fromFieldData.forEach((k: any) => {
                  k.formList.forEach((field: any) => {
                    if (field.fieldKey === item.field) {
                      field.rules[0].message = null
                      nextTick(() => {
                        field.rules[0].message = item.defaultMessage
                      })
                    }
                  })
                })
              })
            }
          }
        })
      },
      handleFormData(formData: any) {
        const returnData = {
          deleteList: [] as ArrayRowsItem
        }
        formData.forEach((k: any) => {
          const _list = [] as ArrayRowsItem
          const accountsObj1 = {}
          k.formList.forEach((field: any) => {
            if (k.type === 1) {
              if (field.config.submitField === 'accounts') {
                field.fieldKey = field.fieldKey === 'accountType' ? 'type' : field.fieldKey
                Object.assign(accountsObj1, dataMap.handleFieldData(field))
              } else {
                Object.assign(returnData, dataMap.handleFieldData(field))
              }
            } else if (k.type === 2) {
              const _obj = {
                id: field.id
              }
              const accountsObj = {}
              field.list.forEach((k: any) => {
                if (k.config.submitField === 'accounts') {
                  k.fieldKey = k.fieldKey === 'accountType' ? 'type' : k.fieldKey
                  Object.assign(accountsObj, dataMap.handleFieldData(k))
                } else {
                  Object.assign(_obj, dataMap.handleFieldData(k))
                }
              })
              Object.keys(accountsObj).length && Object.assign(_obj, { account: accountsObj })
              _list.push(_obj)
              returnData[field.fieldKey] = _list
            }
          })
          Object.keys(accountsObj1).length && Object.assign(returnData, { account: accountsObj1 })
        })
        const _deleteList = [] as ArrayRowsItem
        dataMap.deleteList.forEach((field: any) => {
          let _obj = {
            id: field.id
          }
          field.list.forEach((k: any) => {
            _obj = Object.assign(_obj, dataMap.handleFieldData(k))
          })
          _deleteList.push(_obj)
        })
        returnData.deleteList = _deleteList

        props.handleResolveTempData && props.handleResolveTempData(returnData)
        return returnData
      },
      handleFieldData(fields: any) {
        if (fields.fieldKey) {
          fields = cloneDeep(fields)
          const returnObj = {}
          returnObj[fields.fieldKey] = fields.value
          return returnObj
        }
      },
      clearValidate() {
        nextTick(() => {
          dataForm.value.forEach((form: any) => {
            form.clearValidate()
          })
        })
      },
      calcRate(fields: any, formList: any) {
        const temtList = formList.filter((item: any) => ['fee', 'orderTaxRate', 'orderFee'].includes(item.fieldKey))
        const tempData = {} as any
        temtList.forEach((kk: any) => {
          tempData[kk.fieldKey] = kk.value * 1
        })
        tempData.amount = props.businessDetail?.amount
        let retunValue = ''
        if (fields.config.convert) {
          retunValue = fields.config.convert(tempData)
        }
        return retunValue
      },
      handleDefaultCustomerCompanyId() {
        dataMap.fromFieldData.forEach((item: any) => {
          item.formList.forEach((field: any) => {
            field.list.forEach((k: any) => {
              if (k.fieldKey === 'customerCompanyId') {
                k.value = props.businessDetail?.customerCompanyId
                nextTick(() => {
                  dataMap.handleChange(k, field.list)
                })
              }
            })
          })
        })
      }
    })
    onMounted(() => {
      dataMap.clearValidate()
      dataMap.handleDefaultCustomerCompanyId()
    })
    return {
      t,
      ...toRefs(dataMap),
      dataForm
    }
  }

})
</script>
